import EditWorkOrderMenuItem from "../EditWorkOrderMenuItem/EditWorkOrderMenuItem";
import DeleteWorkOrderMenuItem from "../DeleteWorkOrderMenuItem/DeleteWorkOrderMenuItem";

export default function WorkOrderMenuItems({
  workOrder,
  closeMenu,
}: {
  workOrder: any;
  closeMenu: () => void;
}) {
  return (
    <>
      <EditWorkOrderMenuItem closeMenu={closeMenu} object={workOrder} />
      <DeleteWorkOrderMenuItem closeMenu={closeMenu} object={workOrder} />
    </>
  );
}
